import React, { useContext, useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import playTube from "../assets/logo-no-background.png";
import playTubeMobile from "../assets/logo-colorfevicon.png";
import LazyImage from "./LazyImage";

// removed unused icons
import { IoIosSearch } from "react-icons/io";
import { MdOutlineLightMode } from "react-icons/md";
import { MdDarkMode } from "react-icons/md";
import { MdBookmarkBorder } from "react-icons/md";

import { DataContext } from "../context/contextApi";
import Loader from "../shared/Loader";
// UseOnline removed (not currently used in UI)

const Header = () => {
  const [searchQuery, setSearchQuery] = useState("");

  const { loading, theme, setTheme } = useContext(DataContext);

  const navigate = useNavigate();

  // custom hook for online/offline feature (kept in case we enable its UI later)
  // const isOnline = UseOnline();

  // Clear the search input on full page reloads and on browser back/forward navigation.
  // - On refresh the component is re-mounted, so clearing here ensures an empty field.
  // - `popstate` fires for back/forward navigation in browsers; clear the input then.
  useEffect(() => {
    setSearchQuery("");
    const onPop = () => setSearchQuery("");
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);

  const searchQueryHandler = (event) => {
    if (
      (event?.key === "Enter" || event === "searchButton") &&
      searchQuery?.length > 0
    ) {
      navigate(`/searchResult/${encodeURIComponent(searchQuery)}`);
    }
  };
  const searchQueryHandler2 = () => {
    if (searchQuery?.length > 0) {
      navigate(`/searchResult/${encodeURIComponent(searchQuery)}`);
    }
  };

  const handleThemeSwitch = () => {
    setTheme(theme === "dark" ? "light" : "dark");
  };

  // mobile menu removed

  //I don't want to show menu or leftNav for videoDetails page. for that reason i fetch the path name and use it wisely for video router.
  // const { pathname } = useLocation();
  // const pageName = pathname?.split("/")?.filter(Boolean)?.[0];

  return (
    <div className="fixed top-0 left-0 right-0 z-50 w-full flex flex-row h-14 px-4 md:px-5 justify-between items-center bg-white dark:bg-black shadow-none">
      {loading && <Loader />}

      <div className="flex h-8 items-center">
        <Link to="/" className="flex items-center">
          <LazyImage
            src={playTube}
            srcSet={`${playTubeMobile} 40w, ${playTube} 128w`}
            sizes="(max-width: 768px) 40px, 128px"
            alt="A2Z anime & Cartoons"
            className="h-8 w-auto"
            style={{ objectFit: 'contain' }}
          />
        </Link>
      </div>

  <div className="group flex items-center flex-1 mx-2 md:mx-0 lg:max-w-[720px]">
        <div className="flex h-8 md:h-10 md:ml-10 md:pl-5 border border-[#404040] rounded-l-3xl group-focus-within:border-blue-500 md:group-focus-within:ml-5 md:group-focus-within:pl-0 flex-1 min-w-0">
          <div className="w-10 justify-center items-center hidden group-focus-within:md:flex">
            <IoIosSearch className="text-black/[0.7] dark:text-white text-xl" />
          </div>
          <input
            type="text"
            value={searchQuery}
            placeholder="Search"
            onChange={(e) => setSearchQuery(e.target.value)}
            onKeyUp={searchQueryHandler}
            className="w-full px-4 sm:px-5 bg-transparent outline-none text-black dark:text-white md:pl-0 min-w-0"
          />
        </div>
        <button
          onClick={searchQueryHandler2}
          className="w-[40px] md:w-[60px] h-8 md:h-10 flex items-center justify-center border border-l-0 border-[#404040] rounded-r-3xl bg-black/[0.1] dark:bg-white/[0.15]"
        >
          <IoIosSearch className="text-black/[0.9] dark:text-white text-xl" />
        </button>
      </div>

      <div className="flex items-center">
        <div className="hidden md:flex">
          <div
            onClick={handleThemeSwitch}
            className="flex justify-center items-center ml-2 h-10 w-10 rounded-full hover:bg-black/[0.2] dark:hover:bg-[#303030]/[0.6]"
          >
            {theme === "dark" ? (
              <MdOutlineLightMode className="text-white text-xl cursor-pointer" />
            ) : (
              <MdDarkMode className="text-[#3a5171] text-xl cursor-pointer" />
            )}
          </div>
          <Link
            to="/favorites"
            className="flex justify-center items-center ml-2 h-10 w-10 rounded-full hover:bg-black/[0.2] dark:hover:bg-[#303030]/[0.6]"
            title="My Favorites"
          >
            <MdBookmarkBorder className="text-black dark:text-white text-xl cursor-pointer" />
          </Link>
        </div>
        {/* mobile controls: show theme toggle and favorites on small screens */}
        <div className="flex items-center md:hidden space-x-2">
          <button
            onClick={handleThemeSwitch}
            aria-label="Toggle theme"
            className="flex justify-center items-center h-9 w-9 rounded-full hover:bg-black/[0.06] dark:hover:bg-[#303030]/[0.6]"
          >
            {theme === "dark" ? (
              <MdOutlineLightMode className="text-white text-lg" />
            ) : (
              <MdDarkMode className="text-[#3a5171] text-lg" />
            )}
          </button>

          <Link
            to="/favorites"
            title="My Favorites"
            className="flex justify-center items-center h-9 w-9 rounded-full hover:bg-black/[0.06] dark:hover:bg-[#303030]/[0.6]"
          >
            <MdBookmarkBorder className="text-black dark:text-white text-lg" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Header;
